import { IsNotEmpty, IsOptional, IsString, IsUUID } from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

export class CreateSchoolGroupDto {
  @ApiProperty({
    description: "ID de l'établissement",
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsNotEmpty()
  @IsString()
  establishmentId!: string

  @ApiProperty({
    description: 'Nom du groupe',
    example: 'Groupe A',
    type: 'string',
  })
  @IsNotEmpty()
  @IsString()
  name!: string

  @ApiPropertyOptional({
    description: 'Description du groupe',
    type: 'string',
  })
  @IsOptional()
  @IsString()
  description?: string

  @ApiProperty({
    description: 'ID du type de groupe',
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsNotEmpty()
  @IsUUID('4')
  typeId!: string

  @ApiProperty({
    description: "ID de l'année scolaire",
    example: '550e8400-e29b-41d4-a716-446655440000',
    type: 'string',
  })
  @IsNotEmpty()
  @IsUUID('4')
  schoolYearId!: string
}
